import useSite from "@casino/legacy/client/hooks/useSite";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import NextLink from "@casino/legacy/client/shared/NextLink";
import type PageSectionProps from "@casino/legacy/client/shared/PageSection/PageSectionProps";
import { cn } from "@workspace/frontend-ui";

const TitleIdPlaceholder: FC<PageSectionProps> = ({ titleId, href }) => {
  const { siteConfig, isBitcasino } = useSite();

  if (titleId && href) {
    return (
      <NextLink href={href}>
        <h4
          className={cn(
            "whitespace-nowrap text-xl/8 font-semibold",
            isBitcasino && "font-headline font-light",
          )}
        >
          {titleId && (
            <Translate id={titleId} values={{ siteName: siteConfig.name }} />
          )}
        </h4>
      </NextLink>
    );
  }
  return null;
};

export default TitleIdPlaceholder;
